import axios from "axios";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { useScreenClass } from "react-grid-system";
import { Col, Row } from "../../components/StyledGridSystem";
import { UserContext } from "../../context/UserContext";
import styled from "styled-components";
import { StyledTableCell, StyledTableRow } from "../../components/Table";
import TableComponent from "../../components/Table";
import Card from "../../components/Card";
import {
  Button,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SemesterContext } from "../../context/SemesterContext";
import SnackBar from "../../components/SnackBar";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { StyledText, TextSize } from "../../components/Text";
import Status from "../../types/enum/Status";
import ViewDetailModal from "../Credits/ViewDetailModal";
import { StyledAddButton } from "../RoadMap/RoadMap";
import SelectStudentModal from "../../components/SelectStudentModal";
import Icon from "../../components/Icon";
import { UnsatisfiedCategoryTable } from "./UnstasfiedCategoryTable";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable"; // Import autoTable plugin
import CMKLLogoImage from "../../assets/cmkl.png";
import a1ceLogoImage from "../../assets/logo.png";
import PreviewModal from "./PreviewModal";
import { handleJWTError } from "../../hooks/jwtErrHandler";

const Skill = styled("div")`
  overflow: hidden;
  padding: 20px;
  width: auto;
  background: rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid #80808029;
  border-radius: 5px;
`;

const CardStyle = styled("div")`
  border-radius: 5px;
  padding: 20px;
  background: linear-gradient(179deg, #1a1d3d, #151835);
  margin-bottom: 15px;
`;

const CustomFlex = styled(FlexBox) <{ $sidebarOpen: boolean }>`
  left: ${({ $sidebarOpen }) => ($sidebarOpen ? "270px" : "100px")};
  z-index: 1000;
  position: fixed;
  top: 0px;
  height: 74px;
}
`;
const RotatingIconWrapper = styled.div<{ $isOpen: boolean }>`
  transition: transform 0.25s ease-in-out;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  cursor: pointer;
`;
const CollapsibleContent = styled(Col) <{ $isOpen: boolean }>`
  padding: 0;
  transition: max-height 0.25s ease-in-out;
  max-height: ${({ $isOpen }) => ($isOpen ? "800px" : "0")}; // Set max-height
  overflow: hidden; // Hide overflow to prevent content spilling
`;
type Card = {
  assessed_skills: number;
  competency_code: string;
  credit: number;
  id: string;
  mastery_level: number;
  mastery_level_title: string;
  required: boolean;
  status: string;
  title: string;
  total_skills: number;
  transferred: boolean;
  action: any;
  detail: any;
};
interface Column {
  id: "competency_code" | "title" | "credit" | "detail";
  label: string;
  minWidth?: number;
  align?: "right" | "left" | "center";
  format?: (value: number) => string;
}

interface GraduationStatus {
  gpa: number;
  qpa: number;
  expected_graduation_semester: string;
  required_course_not_taken: RequiredCourseNotTaken[];
  soft_skill_requirements: SoftSkillRequirement[];
  overall_credit: {
    total_required_credits: number;
    total_earned_credits: number;
  };
  distribution_area_credit: {
    [key: string]: {
      total_required_credits: number;
      total_earned_credits: number;
      total_working_credits: any;
    };
  };
  unsatisfied_option_group: UnsatisfiedOptionGroups[];
}

interface RequiredCourseNotTaken {
  id: string;
  competency_code: string;
  title: string;
  credit: number;
  detail: string;
}

interface SoftSkillRequirement {
  competency_code: string;
  competency_title: string;
  semesters_completed: number;
  avg_mastery_level: number;
  status: boolean;
}
interface UnsatisfiedOptionGroups {
  competencies: any;
  curriculum_version: string;
  option_group_credit: number;
  option_group_id: number;
  required_count: number;
  title: string;
}

interface ColumnSoftSkill {
  id:
  | "competency_code"
  | "competency_title"
  | "semesters_completed"
  | "avg_mastery_level"
  | "status";
  label: string;
  minWidth?: number;
  align?: "right" | "left" | "center";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "competency_code", label: "Competency Code", minWidth: 100 },
  { id: "title", label: "Competency Title", minWidth: 200 },
  {
    id: "credit",
    label: "Credits",
    minWidth: 80,
    align: "left",
    format: (value: number) => value.toLocaleString("en-US"),
  },

  // {
  //   id: "detail",
  //   label: "",
  //   minWidth: 10,
  // },
];
const columnsSoftSkill: readonly ColumnSoftSkill[] = [
  { id: "competency_code", label: "Competency Code", minWidth: 100 },
  { id: "competency_title", label: "Competency Title", minWidth: 200 },
  {
    id: "semesters_completed",
    label: "Semesters",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "avg_mastery_level",
    label: "Average Mastery",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "status",
    label: "Requirement Satisfied?",
    minWidth: 200,
  },
];
function GraduateReportStatusPage() {
  const screenClass = useScreenClass();
  const [graduationStatusData, setGraduationStatusData] =
    useState<GraduationStatus>({
      gpa: 0,
      qpa: 0,
      expected_graduation_semester: "",
      required_course_not_taken: [],
      soft_skill_requirements: [],
      overall_credit: {
        total_required_credits: 0,
        total_earned_credits: 0,
      },
      distribution_area_credit: {},
      unsatisfied_option_group: [],
    });

  const [credits, setCredits] = useState<Array<Card>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isMessageOpen, setIsMessageOpen] = useState<boolean>(false);
  const [totalCredits, setTotalCredits] = useState(0);
  const [totalRecordedCredits, setRecordedCredits] = useState(0);
  const [messageType, setMessageType] =
    useState<"error" | "success" | "warning" | "info">("error");
  const [message, setMessage] = useState<string>("");
  const [messageHeader, setMessageHeader] = useState<string>("");
  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState({});
  const currentUser = useContext(UserContext).user;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isReqCourseOpen, setIsReqCourseOpen] = useState<boolean>(false);
  const [isUnsatisfiedOpen, setIsUnsatisfiedOpen] = useState<boolean>(false);
  const [isRequiredExpand, setIsRequiredExpand] = useState<boolean>(false);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

  const userContext = useContext(UserContext);

  const semesterContext = useContext(SemesterContext);

  const selectedStudent: any = JSON.parse(
    localStorage.getItem("selectedStudent") as string
  );

  function scrollToComponent(id: string) {
    // Add a delay that matches the collapse animation duration
    setTimeout(() => {
      document?.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300); // Adjust this timing based on the collapse animation duration
  }

  const tableRef: any = useRef(null); // Reference to the table element

  const exportToPDF = async () => {
    const doc: any = new jsPDF();

    const formattedDate = new Date().toLocaleString("en-GB", {
      month: "short", // "Jan"
      day: "2-digit", // "17"
      year: "numeric", // "2025"
      hour: "2-digit", // "13"
      minute: "2-digit", // "08"
    });

    // Add title and first table on the first available page
    doc.setFontSize(16);
    doc.text("Graduation Status Report", 78, 15);

    doc.setFontSize(10);
    userContext?.user?.cie_dual_degree && doc.text("(AiCE and CIE Dual Degree)", 88, 20);

    doc.setFontSize(10);
    // Left-aligned text
    doc.text(
      `Name: ${currentUser.first_name + " " + currentUser.last_name}`,
      14,
      30
    );
    doc.text(`Date: ${formattedDate}`, 14, 37);
    doc.text(
      `Expected Graduation Semester: ${graduationStatusData?.expected_graduation_semester || "N/A"
      }`,
      14,
      44
    );

    // Right-aligned text
    const pdfWidth = doc.internal.pageSize.getWidth(); // Get the page width
    const rightMargin = 14; // Adjust margin from the right side
    const rightX = pdfWidth - rightMargin; // Calculate X position for right alignment

    // Add the left logo to the top-left corner
    const logoWidth = 25; // Adjust the width of the logo
    const logoHeight = 10; // Adjust the height of the logo
    doc.addImage(CMKLLogoImage, "PNG", 10, 10, logoWidth, logoHeight);

    // Add the right logo to the top-right corner
    doc.addImage(a1ceLogoImage, "PNG", pdfWidth - 22, 10, 10, 10);

    doc.text(`Current QPA:   ${graduationStatusData?.qpa}`, rightX, 30, {
      align: "right",
    });
    doc.text(
      `Required Credits: ${graduationStatusData?.overall_credit.total_required_credits}`,
      rightX,
      37,
      { align: "right" }
    );
    doc.text(
      `Earned Credits: ${graduationStatusData?.overall_credit.total_earned_credits}`,
      rightX,
      44,
      { align: "right" }
    );
    doc.text(
      `Remaining Credits: ${graduationStatusData?.overall_credit.total_required_credits -
      graduationStatusData?.overall_credit.total_earned_credits
      }`,
      rightX,
      51,
      { align: "right" }
    );

    doc.setFontSize(14);
    doc.text("Credits by Distribution Area", 14, 60);

    const creditData = Object.entries(
      graduationStatusData?.distribution_area_credit
    )
      ?.filter(([key, value]) => key !== "soft_skill")
      .map(([key, value]) => [
        key === "core_technical"
          ? skillNames[0]
          : key === "science_math"
            ? skillNames[1]
            : key === "communication_art_social"
              ? skillNames[2]
              : key === "research_development"
                ? skillNames[3]
                : key === "xp"
                  ? skillNames[4]
                  : "Soft Skill",
        value.total_required_credits,
        value.total_earned_credits,
        value.total_required_credits - value.total_earned_credits < 0
          ? 0
          : value.total_required_credits - value.total_earned_credits,
      ]);
    const distributionColumn = [
      "Distribution Area",
      "Required Credits",
      "Earned Credits",
      "Remaining Credits",
    ];

    // Calculate Y position for table 1
    let startY = 60;

    doc.autoTable({
      startY: startY + 5,
      head: [distributionColumn],
      body: creditData,
      theme: "striped",
    });

    // Update startY to position for Table 2
    startY = doc.lastAutoTable.finalY + 10; // Add 10 units of space between tables

    // doc.addPage();
    // startY = 20;
    const tableData = graduationStatusData?.required_course_not_taken
      .filter((row) => !row.competency_code.includes("SOF")) // Exclude SOF
      .map((row) => [row.competency_code, row.title, row.credit]);

    const column = columns.map((col: any) => {
      return { header: col.label, dataKey: col.id };
    });

    doc.autoTable({
      startY: startY + 5, // Space below the title
      head: [column.map((col: any) => col.header)],
      body: tableData,
      theme: "striped",
    });

    // Update startY to position for Table 3
    startY = doc.lastAutoTable.finalY + 10; // Add 10 units of space between tables

    // Add another page if necessary
    if (startY > doc.internal.pageSize.height - 30) {
      doc.addPage();
      startY = 20; // Reset startY for new page
    }

    doc.text("Unsatisfied Competency Categories", 14, startY);

    // Process the data
    const unsatisfiedTableData =
      graduationStatusData.unsatisfied_option_group.map((group) => {
        // Parent row (option group)
        const parentRow = [
          group.title,
          group.required_count,
          group.option_group_credit,
        ];

        // Child rows (competencies)
        const childRows = group.competencies.map((competency: any) => [
          `  - ${competency.competency_code}: ${competency.title}`, // Indented child
          "",
          competency.credits,
        ]);

        return [parentRow, ...childRows];
      });

    // Flatten the rows for rendering
    const flattenedData = unsatisfiedTableData.flat();

    // Header for the table
    const headers = [["Title", "Required Count", "Credits"]];

    // Generate the table
    doc.autoTable({
      startY: startY + 5,
      head: headers,
      body: flattenedData,
      theme: "striped",
      styles: {
        cellPadding: 4,
        fontSize: 10,
      },
      didParseCell: (data: any) => {
        // Check if it's a parent row
        if (!data.row.raw[0]?.startsWith("  -")) {
          data.cell.styles.fontStyle = "bold"; // Bold font for parent rows
        }
        // Customize the styling for child rows
        if (data.row.raw[0]?.startsWith("  -")) {
          data.cell.styles.fontStyle = "italic"; // Italic font for child rows
          data.cell.styles.textColor = "#555"; // Grey color for child rows
        }
      },
    });

    const pdfOutput = doc.output("blob");
    setPdfBlob(pdfOutput);
    // Save the PDF
    // doc.save(
    //   `${currentUser.first_name.toLowerCase()}_${currentUser.last_name.toLowerCase()}_graduation.pdf`
    // );
  };

  useEffect(() => {
    {
      userContext.user.role === 1
        ? fetchGraduation(currentUser.id)
        : selectedStudent && fetchGraduation(selectedStudent?.id);
    }
    // fetchCredits(currentUser.id);
  }, [currentUser, semesterContext]);

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  const fetchCredits = (id: string) => {
    setLoading(true);
    axios
      .get(
        `/student/cards/semester?student_id=${id}&semester_name=${semesterContext.selectedSemester?.label}&program_name=${userContext.user?.programs?.[0]?.program_name}`
      )
      .then((res) => {
        if (res.data.card_info.cards) {
          setCredits(res.data.card_info.cards);
          const total = res.data.card_info.cards.reduce(
            (sum: number, competency: any) => sum + competency.credits,
            0
          );
          const totalRecordedCredits = res.data.card_info.cards.reduce(
            (sum: number, competency: any) => {
              if (competency.status === "Recorded") {
                return sum + competency.credits;
              }
              return sum;
            },
            0
          );
          setTotalCredits(total);
          setRecordedCredits(totalRecordedCredits);
        } else {
          setCredits([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        handleJWTError(error);
        setCredits([]);
        setLoading(false);
      });
  };
  const fetchGraduation = (id: string) => {
    id &&
      axios
        .get(`/student/graduation/status?student_id=${id}&program_name=${currentUser.programs?.[0]?.program_name}`)
        .then((res) => {
          const graduationStatus = res.data.graduationstatus;
          if (graduationStatus) {
            const gpa = graduationStatus.gpa;
            setGraduationStatusData(graduationStatus);
          } else {
            console.log("Graduation status not found");
          }
        })
        .catch((error) => {
          handleJWTError(error);
          if (error.response?.data?.error === "no gpa") {
          } else {
            console.log("An error occurred:", error);
          }
        });
  };

  const CreditStyle = styled("div")`
    padding: 5px;
    display: flex;
    justify-content: start;
    align-items: center;
    // color: #2fff00;
    font-weight: bold;
  `;

  const skillNames = [
    "Core Technical",
    "Science & Math",
    "Communications/Arts/Social Science",
    "Research & Development",
    "XP",
    // "SOF",
  ];
  const skillMapping: { [key: string]: string } = {
    "Core Technical": "core_technical",
    "Science & Math": "science_math",
    "Communications/Arts/Social Science": "communication_art_social",
    "Research & Development": "research_development",
    XP: "xp",
    SOF: "soft_skill",
  };
  if (loading) {
    return <LoadingSpinner />;
  }

  console.log('userContext', userContext.user)
  return (
    <>
      {/* {isModalOpen && (
        <SelectStudentModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setStudent={(stu) => {
            localStorage.setItem("selectedStudent", JSON.stringify(stu));
            fetchGraduation(stu?.id);
          }}
        />
      )} */}
      {pdfBlob && (
        <PreviewModal
          setOpen={() => setPdfBlob(null)}
          isOpen={pdfBlob !== null}
          pdfBlob={pdfBlob}
        />
      )}
      <ViewDetailModal
        credits={credits}
        title="Skills"
        isOpen={isDetailOpen}
        setOpen={setIsDetailOpen}
        selectedRow={selectedRow}
      />
      <SnackBar
        isOpen={isMessageOpen}
        setOpen={setIsMessageOpen}
        header={messageHeader}
        message={message}
        type={messageType}
      />{" "}
      <h3
        style={{
          position: "fixed",
          zIndex: 999999,
          left: "50%",
          top: 10,
          transform: "translateX(-50%)",
        }}
      >
        <div style={{textAlign:'center'}}>
        Graduation Status Report <br/><span style={{fontSize:14}}>{userContext?.user?.cie_dual_degree && "(AiCE and CIE Dual Degree)"}</span>
        </div>
      </h3>
      {/* {userContext.user.role !== 1 && (
        <CustomFlex $sidebarOpen={userContext.roadmapView.sidebar}>
          <FlexGrow style={{ flexGrow: 0 }}>
            <StyledAddButton
              style={{
                margin: 0,
                whiteSpace: "nowrap",
                fontWeight: "600",
              }}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              {!isMobile && window.screen.width > 1140 ? (
                <>
                  {selectedStudent && selectedStudent.nickname ? (
                    <>
                      <Icon
                        fixedWidth={false}
                        style={{ width: "24px", height: "24px" }}
                        size={3}
                        mr={1}
                        name="user"
                      />
                      {selectedStudent.nickname}
                    </>
                  ) : (
                    <>
                      <Icon
                        fixedWidth={false}
                        style={{ width: "24px", height: "24px" }}
                        size={3}
                        mr={1}
                        name="user"
                      />
                      Select Student
                    </>
                  )}
                </>
              ) : (
                <>
                  <Icon
                    fixedWidth={false}
                    style={{ width: "24px", height: "24px" }}
                    size={3}
                    name="plus-circle"
                  />
                </>
              )}
            </StyledAddButton>
          </FlexGrow>
        </CustomFlex>
      )} */}
      {userContext.user.role !== 1 && !selectedStudent ? (
        <div
          style={{
            display: "flex",
            background:
              "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
            color: "white",
            padding: 20,
            fontSize: "bold",
          }}
        >
          <Icon
            fixedWidth={false}
            style={{ width: "24px", height: "24px" }}
            size={3}
            mr={1}
            name="info-circle"
          ></Icon>
          Select a student !
        </div>
      ) : (
        <>
          <FlexBox justify="end">
            <Button
              style={{
                // padding:10,
                boxShadow: "0 2px 4px #00000063",
                padding: "10px 50px",
                borderRadius: 5,
                color: "white",
                marginTop: "5px",
                background:
                  "linear-gradient(90deg, rgb(176, 52, 52) 0%, #f00 118.29%)",
                position: "fixed",
                top: 85,
                right: 20,
                zIndex: 100,
              }}
              onClick={exportToPDF}
            >
              <Icon
                size={3.5}
                name="download-alt"
                style={{ paddingRight: 10 }}
              />
              Export to PDF
            </Button>
          </FlexBox>

          <CardStyle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // margin: "10px",
              }}
            >
              <CreditStyle>
                Current QPA{" "}
                <div
                  style={{
                    border: "1px solid #86868636",
                    marginLeft: 10,
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: 5,
                    fontWeight: "normal",
                    display: "flex",
                    gap: 5,
                  }}
                >
                  <span style={{ color: "#3cff3c" }}>
                    {graduationStatusData.qpa}
                  </span>
                  {/* ,
                  <span style={{ color: "#ffae42" }}>
                    {" "}
                    Cumulative GPA : N/A
                  </span> */}
                </div>
              </CreditStyle>
              <CreditStyle>
                Expected Graduation Semester{" "}
                <div
                  style={{
                    border: "1px solid #86868636",
                    marginLeft: 10,
                    color: "#3cff3c",
                    padding: "5px 10px",
                    borderRadius: 5,
                    fontWeight: "normal",
                  }}
                >
                  {graduationStatusData.expected_graduation_semester || "N/A"}
                </div>
              </CreditStyle>
              <CreditStyle>
                Overall Credits{" "}
                <div
                  style={{
                    border: "1px solid #86868636",
                    marginLeft: 10,
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: 5,
                    fontWeight: "normal",
                    display: "flex",
                    gap: 5,
                  }}
                >
                  <span style={{ color: "#dddddd" }}>
                    Required :{" "}
                    {
                      graduationStatusData.overall_credit
                        ?.total_required_credits
                    }
                  </span>
                  ,{" "}
                  <span style={{ color: "#3cff3c" }}>
                    Earned :{" "}
                    {graduationStatusData?.overall_credit?.total_earned_credits}
                  </span>
                  ,{" "}
                  <span style={{ color: "#ffae42" }}>
                    Remaining:{" "}
                    {graduationStatusData?.overall_credit
                      ?.total_required_credits -
                      graduationStatusData?.overall_credit
                        ?.total_earned_credits >
                      -1
                      ? graduationStatusData?.overall_credit
                        ?.total_required_credits -
                      graduationStatusData?.overall_credit
                        ?.total_earned_credits
                      : 0}
                  </span>
                </div>
              </CreditStyle>
              {/* {semesterContext.selectedSemester?.is_open && (
          
        )} */}
            </div>
          </CardStyle>
          <CardStyle>
            <CreditStyle>Credits by Distribution Area </CreditStyle>
            <div
              className="visible-scrollbar"
              style={{
                display: "grid",
                gridTemplateColumns:
                  screenClass === "xxl" || screenClass === "xl"
                    ? "repeat(3, 1fr)"
                    : "repeat(2, 1fr)",
                gap: 15,
                padding: "25px 0px",
                maxHeight: "50vh",
                overflow: "auto",
              }}
            >
              {skillNames.map((name: string, index: number) => {
                const skillKey = skillMapping[name];

                const requiredCredits =
                  graduationStatusData.distribution_area_credit[skillKey]
                    ?.total_required_credits || 0;
                const earnedCredits =
                  graduationStatusData.distribution_area_credit[skillKey]
                    ?.total_earned_credits || 0;
                const remainingCredits =
                  requiredCredits - earnedCredits > -1
                    ? requiredCredits - earnedCredits
                    : 0;

                return (
                  <Skill
                    key={index}
                    style={{
                      boxShadow: "0px 1px 5px black",
                      // border: "1px solid #1d1c1c",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      {name}
                    </div>
                    <div style={{ width: "100%" }}>
                      <div>
                        <StyledText
                          // status={TextStatus.muted}
                          style={{
                            fontSize: "12px",
                            display: "flex",
                            gap: 5,
                            alignItems: "end",
                          }}
                          fontWeight="normal"
                        >
                          <span style={{ color: "#dddddd" }}>
                            {" "}
                            Required: {requiredCredits}
                          </span>
                          ,
                          <span style={{ color: "#3cff3c" }}>
                            {" "}
                            Earned: {earnedCredits}
                          </span>
                          ,
                          <span style={{ color: "#ffae42" }}>
                            {" "}
                            Remaining: {remainingCredits}
                          </span>
                        </StyledText>
                      </div>
                    </div>
                  </Skill>
                );
              })}
              <div id="required-competency-bottom" />
            </div>
          </CardStyle>

          <CardStyle>
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                cursor: "pointer",
              }}
            // onClick={() => {
            //   setIsReqCourseOpen(!isReqCourseOpen);
            //   scrollToComponent("required-competency-bottom");
            // }}
            >
              {/* <RotatingIconWrapper $isOpen={isReqCourseOpen}>
                <Icon
                  // fixedWidth={false}
                  style={{
                    // width: "30px",
                    // height: "30px",
                    color: "#03a9f4",
                  }}
                  size={3.5}
                  name="angle-down"
                />
              </RotatingIconWrapper> */}
              Required Competencies Not Yet Completed
            </div>
            <CollapsibleContent $isOpen={true}>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <FlexBox style={{ marginTop: 20 }}>
                  {graduationStatusData?.required_course_not_taken ? (
                    <TableContainer
                      ref={tableRef}
                      style={{
                        // overflowY: "auto",
                        background: "transparent",
                        // maxHeight: "300px", // Ensure the container has scroll
                      }}
                    >
                      <TableComponent aria-label="sticky table" height={"auto"}>
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  fontWeight: "bold",
                                  borderBottom: "1px solid #3C406C",
                                }}
                              >
                                {column.label}
                              </StyledTableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {graduationStatusData?.required_course_not_taken
                            ?.length === 0 ? (
                            <>
                              <StyledTableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={0}
                              >
                                <StyledTableCell
                                  colSpan={6}
                                  key={1}
                                  align="center"
                                >
                                  No competencies
                                </StyledTableCell>
                              </StyledTableRow>
                            </>
                          ) : (
                            <>
                              {graduationStatusData?.required_course_not_taken?.map(
                                (row, index) => {
                                  if (
                                    !row.competency_code.includes("SOF") &&
                                    (!isRequiredExpand ? index < 3 : index > -1)
                                  )
                                    return (
                                      <StyledTableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={index}
                                      >
                                        {columns.map((column: Column) => {
                                          const value = row[column.id];

                                          return (
                                            <StyledTableCell
                                              key={column.id}
                                              align={column.align}
                                              sx={{
                                                color: "white",
                                                // border: "1px solid #3C406C",
                                                // borderBottom: "unset",
                                                minWidth: "157px",
                                                width: "157px",
                                                maxWidth: "157px !important",
                                              }}
                                            >
                                              {column.format &&
                                                typeof value === "number"
                                                ? column.format(value)
                                                : value}
                                            </StyledTableCell>
                                          );
                                        })}
                                      </StyledTableRow>
                                    );
                                }
                              )}
                            </>
                          )}
                        </TableBody>
                      </TableComponent>
                    </TableContainer>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {/* <span
                        style={{
                          background:
                            "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
                          padding: 10,
                          borderRadius: 5,
                        }}
                      >
                        No Data
                      </span> */}
                    </div>
                  )}
                  <div
                    onClick={() => {
                      setIsRequiredExpand(!isRequiredExpand);
                      scrollToComponent("required-competency-bottom");
                      setIsUnsatisfiedOpen(false);
                    }}
                    style={{
                      width: "100%",
                      textAlign: "center",
                      cursor: "pointer",
                      color: "#03a9f4",
                      marginTop: 5,
                    }}
                  >
                    {isRequiredExpand ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        See Less{" "}
                        <Icon
                          // fixedWidth={false}
                          style={{
                            color: "#03a9f4",
                          }}
                          size={3.5}
                          name={"angle-up"}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        See More{" "}
                        <Icon
                          // fixedWidth={false}
                          style={{
                            color: "#03a9f4",
                          }}
                          size={3.5}
                          name={"angle-down"}
                        />
                      </div>
                    )}
                  </div>
                </FlexBox>
              )}
            </CollapsibleContent>
          </CardStyle>

          <CardStyle>
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsUnsatisfiedOpen(!isUnsatisfiedOpen);
                scrollToComponent("unsatisfied-bottom");
                setIsRequiredExpand(false);
              }}
            >
              <RotatingIconWrapper $isOpen={isUnsatisfiedOpen}>
                <Icon
                  // fixedWidth={false}
                  style={{
                    // width: "30px",
                    // height: "30px",
                    color: "#03a9f4",
                  }}
                  size={3.5}
                  name="angle-down"
                />
              </RotatingIconWrapper>
              Unsatisfied Competency Categories
            </div>
            <CollapsibleContent $isOpen={isUnsatisfiedOpen}>
              {
                <div style={{ marginTop: 20 }}>
                  <UnsatisfiedCategoryTable
                    data={graduationStatusData?.unsatisfied_option_group}
                  />
                </div>
              }
            </CollapsibleContent>
            <div id="unsatisfied-bottom"></div>
          </CardStyle>
        </>
      )}
    </>
  );
}
export default GraduateReportStatusPage;
